import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DropdownItem } from 'app/event/models/dropdown-item';
import { LegalEntity } from 'app/event/models/legal-entity';
import { LegalEntitySearch } from 'app/event/models/legal-entity-search';
import { Party } from 'app/event/models/party';
import { CommonDataStore } from 'app/event/service/common-data/common-data.store';
import { PioneerValidators } from 'app/shared/utils/pioneer.validators';
import { Observable } from 'rxjs/Observable';
import { CommissionService } from '../service/commission.service';

@Component({
  selector: 'pioneer-payment-legal-entity',
  templateUrl: './payment-legal-entity.component.html',
  styleUrls: ['./payment-legal-entity.component.css']
})
export class PaymentLegalEntityComponent implements OnInit {

  @Input() legalEntity: LegalEntity;

  @Output()
  public validForm: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  public resultLegalEntity: EventEmitter<LegalEntity> = new EventEmitter<LegalEntity>();

  states$: Observable<DropdownItem[]>;
  public selectedCountry$: Observable<DropdownItem>;
  public selectedState$: Observable<DropdownItem>;
  public isStateRequired = PioneerValidators.isStateRequired;
  showState = true;

  countries: DropdownItem[];

  legalEntityForm: FormGroup = this.fb.group({
    vatId: ['', [Validators.required, Validators.maxLength(25)]],
    name: ['', [Validators.required, Validators.maxLength(250)]],
    country: ['', [Validators.required, Validators.maxLength(2)]],
    address1: ['', [Validators.required, Validators.maxLength(100)]],
    address2: ['', [Validators.maxLength(100)]],
    address3: ['', [Validators.maxLength(100)]],
    city: ['', [Validators.required, Validators.maxLength(50)]],
    state: ['', [Validators.maxLength(3)]],
    postal: ['', [Validators.maxLength(15)]]
  }, {validator: Validators.compose([
    PioneerValidators.countryStateCrossValidator('country', 'state')
  ])});

  get vatId() { return this.legalEntityForm.get('vatId'); }

  get name() { return this.legalEntityForm.get('name'); }

  get country() { return this.legalEntityForm.get('country'); }

  get address1() { return this.legalEntityForm.get('address1'); }

  get address2() { return this.legalEntityForm.get('address2'); }

  get address3() { return this.legalEntityForm.get('address3'); }

  get city() { return this.legalEntityForm.get('city'); }

  get state() { return this.legalEntityForm.get('state'); }

  get postal() { return this.legalEntityForm.get('postal'); }

  constructor(
    private fb: FormBuilder,
    private commonDataStore: CommonDataStore
  ) { }

  ngOnInit() {

    this.commonDataStore.loadCountries().subscribe(countries => {
      this.countries = countries;
    });

    this.populateLegalEntityInfo();

    this.legalEntityForm.statusChanges.subscribe((result) => {
      const validForm = result === 'VALID' ? true : false;
      this.validForm.emit(validForm);
      if (validForm) {
        this.resultLegalEntity.emit(this.getResultLegalEntity());
      }
    });

    this.states$ = this.commonDataStore.states;
    this.states$.subscribe((states) => {
      if (states && states.length > 0) {
        const stateFormControl = this.legalEntityForm ? this.legalEntityForm.get('state') : undefined;
        if (stateFormControl) {
          stateFormControl.enable();
        }
      }
    });

    this.commonDataStore.loadStatesFromCountry(this.country.value).take(1).subscribe();

    this.selectedCountry$ = this.commonDataStore.getCountry(this.country.value);
    if (this.country.value) {
      this.selectedState$ = this.commonDataStore.getState(this.country.value, this.state.value);
    } else {
      this.selectedState$ = Observable.of(new DropdownItem('', this.state.value));
    }

    if (this.legalEntityForm.valid) {
      this.validForm.emit(true);
      this.resultLegalEntity.emit(this.getResultLegalEntity());
    }
  }

  getResultLegalEntity(): LegalEntity {
    this.legalEntity['vatNumberId'] = this.vatId.value;
    this.legalEntity['legalEntityName'] = this.name.value;
    this.legalEntity['country'] = this.country.value;
    this.legalEntity['address1'] = this.address1.value;
    this.legalEntity['address2'] = this.address2.value;
    this.legalEntity['address3'] = this.address3.value;
    this.legalEntity['stateProvince'] = this.state.value;
    this.legalEntity['vatNumberId'] = this.vatId.value;
    this.legalEntity['postalCode'] = this.postal.value;

    return this.legalEntity;
  }

  populateLegalEntityInfo() {
    this.legalEntityForm.patchValue({vatId: this.legalEntity.vatNumberId});
    this.legalEntityForm.patchValue({name: this.legalEntity.legalEntityName});
    this.legalEntityForm.patchValue({country: this.legalEntity.country});
    this.legalEntityForm.patchValue({address1: this.legalEntity.address1});
    this.legalEntityForm.patchValue({address2: this.legalEntity.address2});
    this.legalEntityForm.patchValue({address3: this.legalEntity.address3});
    this.legalEntityForm.patchValue({city: this.legalEntity.city});
    this.legalEntityForm.patchValue({state: this.legalEntity.stateProvince});
    this.legalEntityForm.patchValue({postal: this.legalEntity.postalCode});
  }

  onCountryCodeChanged() {
    this.legalEntityForm.get('state').reset();
    this.states$ = this.commonDataStore.loadStatesFromCountry(this.legalEntityForm.get('country').value);
    this.states$.take(1).subscribe((states: DropdownItem[]) => {
      this.showState = states.length > 0;
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-legal-entity/payment-legal-entity.component.ts